/*
 * Module Comment
*/

rs.module("controls/universalsearch/deferredresult",

    ["controls/universalsearch"],

    function (universalSearch) {

        //
        // Initialize
        //
        function initialize(searchId, jsSelectors, backendUrls, responseCountHeaderName) {

            var resultContent = $.js(jsSelectors.resultContent);

            // kick off a POST to the backend url to get results
            $.get(
                {
                    url: backendUrls.getDeferredResults,
                    data: { searchId: searchId },
                }
            ).done(function (html, status, jqXHR) {
                if (jqXHR.status == 204) {
                    removeCategory();
                }
                else {

                    var resultCount = jqXHR.getResponseHeader(responseCountHeaderName);

                    var resultSection = universalSearch.getResultSection(resultContent);
                    universalSearch.deferredResultCompleted(resultSection, html, resultCount);
                }

            }).fail(function (jqXHR) {
                removeCategory()
            });


            function removeCategory() {
                var toRemove = universalSearch.getCategory(resultContent);

                // fade + slide (uses height animation) then remove from DOM
                toRemove.animate(
                    { opacity: 0, height: 0, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 },
                    180, 
                    'swing',
                    function () { $(this).remove(); }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);